<script>
    import Alert from '$lib/components/UI/Alert.svelte'
    export let incorrectFields = []
    $: badFields =
        typeof incorrectFields === 'object'
            ? Object.entries(incorrectFields)
                  .filter(([_, x]) => {
                      let accert = x.required === true && x.valid === false
                      // console.log(`${x.label || x.labelOption} [${accert}] required: ${x.required} | valid: ${x.valid} | value: ${x.value}`);
                      return accert
                  })
                  .map(([k, x]) => [k, x.label || x.labelOption || undefined])
            : []
    $: bf_dp = badFields.filter(([k]) => k.slice(-2) === 'dp')
    $: bf_ii = badFields.filter(([k]) => k.slice(-2) === 'ii')
    $: bf_lp = badFields.filter(([k]) => k.slice(-2) === 'lp')
    $: bf_ac = badFields.filter(([k]) => k.slice(-2) === 'ac')
</script>

{#if badFields.length > 0}
    <Alert alignIcon="flex-start" style="margin: 0 0 12px 0" type="error">
        <p style="margin: 6.5px 0 0 0; padding: 0">
            Por favor revise los siguientes campos:
        </p>
        <ul>
            {#if bf_dp.length > 0}
                <li>
                    Datos del Proveedor
                    <ul>
                        {#each bf_dp as [_, field]}
                            <li>{field}</li>
                        {/each}
                    </ul>
                </li>
            {/if}
            {#if bf_ii.length > 0}
                <li>
                    Información Impositiva
                    <ul>
                        {#each bf_ii as [_, field]}
                            <li>{field}</li>
                        {/each}
                    </ul>
                </li>
            {/if}
            {#if bf_lp.length > 0}
                <li>
                    Información Laboral y Previsional
                    <ul>
                        {#each bf_lp as [_, field]}
                            <li>{field}</li>
                        {/each}
                    </ul>
                </li>
            {/if}
            {#if bf_ac.length > 0}
                <li>
                    Acreditacion de cuenta
                    <ul>
                        {#each bf_ac as [_, field]}
                            <li>{field}</li>
                        {/each}
                    </ul>
                </li>
            {/if}
        </ul>
        <slot />
    </Alert>
{/if}
